import React from "react";
import { Route, RouteProps, Redirect } from "react-router-dom";
import { useAuth } from "src/context/Auth/context";
import getHomePageLink from "src/utils/getHomePageLink";
import RoutePermissions from "./permission";

interface IRouteProps extends Omit<RouteProps, "path">{
    isPrivate?: boolean;
    component: React.ComponentType;
	checkPermission?: boolean;
	path: string;
	permissionPath?: string;
	onlyPublicAccess?: boolean;
}

const RoutePrivate: React.FC<IRouteProps> = ({isPrivate = false, checkPermission = true, component: Component, onlyPublicAccess = false, ...rest}) => { 
	const { user, defaultDashboard, homePage } = useAuth();

	return (
		<Route {...rest} render={ ({location}) => {		
			if(isPrivate === Boolean(user) || (!isPrivate && !onlyPublicAccess))
				return isPrivate && checkPermission && rest.path ? <RoutePermissions component={Component} path={rest.path} permissionPath={rest.permissionPath} /> : <Component />;

			return <Redirect to={{pathname: isPrivate ? "/login" : getHomePageLink(homePage, defaultDashboard), state: { from: location }}}/>;
		}}/>
	);
};

export default RoutePrivate;
